import _styled from "styled-components";
import React from "react";

function circleOffset(props) {
  if (props.indeterminate) {
    return 12;
  }

  if (props.toggled) {
    return 22;
  }

  return 0;
}

function backgroundColor(props) {
  if (props.indeterminate) {
    return "#91eaaa";
  }

  if (props.toggled) {
    return "#24d656";
  }

  return "#ffffff";
}

var Circle = _styled.div.withConfig({
  displayName: "ToggledButton__Circle",
  componentId: "sc-10dkje2-0"
})(["position:absolute;left:0px;bottom:2px;height:33px;width:33px;box-shadow:0px 4px 7px rgba(0,0,0,0.5);border-radius:20px;border:1px solid #a7a8aa;background:white;transition:all ", "s;transform:translateX(", "px);"], function (p) {
  return p.indeterminate ? 0.15 : 0.3;
}, circleOffset);

var ToggledStyled = _styled.button.withConfig({
  displayName: "ToggledButton__ToggledStyled",
  componentId: "sc-10dkje2-1"
})(["position:relative;background-color:", ";height:40px;width:60px;border-radius:20px;border:1px solid #d3d3d3;transition:all ", "s;overflow:hidden;outline:none;cursor:", ";"], backgroundColor, function (p) {
  return p.indeterminate ? 0.15 : 0.3;
}, function (p) {
  return p.indeterminate ? "default" : "pointer";
});

export function ToggledButton(_ref) {
  var on = _ref.on,
      onChange = _ref.onChange,
      indeterminate = _ref.indeterminate;
  return /*#__PURE__*/React.createElement(ToggledStyled, {
    toggled: on,
    indeterminate: indeterminate,
    onClick: onChange
  }, /*#__PURE__*/React.createElement(Circle, {
    toggled: on,
    indeterminate: indeterminate
  }));
}